<template>
  <el-form
    label-width="300px"
    :inline="true"
    :model="form"
    class="demo-form-inline"
  >
    <el-form-item label="电话号码(,分割)输入all发给全部用户" required>
      <el-input v-model="form.users" clearable />
    </el-form-item>
    <el-form-item label="标题" required>
      <el-input v-model="form.title" clearable />
    </el-form-item>
  </el-form>
  <div style="border: 1px solid #ccc">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editorRef"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />
      <Editor
        style="height: 500px; overflow-y: hidden"
        v-model="form.content"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="handleCreated"
      />
    </div>
</template>

<script setup>
import { rolesEnums } from "@/config/enums";
import {
  onBeforeUnmount,
  nextTick,
  ref,
  shallowRef,
  onMounted,
  getCurrentInstance,
} from "vue";
import fileUploadHoook from "@/hooks/fileUpload";
import { htmlDecodeByRegExp } from "@/utils/utils";
import { getTokenAUTH } from "@/utils/auth";

const form = ref({
  users: "",
  title: "",
  content: "",
});
const props = defineProps(["item"]);

const headers = ref({})
const { proxy } = getCurrentInstance();
onMounted(() => {
  headers.value['Accept-Token'] = getTokenAUTH()
  nextTick(() => {
    form.value = Object.assign(form.value, props.item);
    form.value.content = htmlDecodeByRegExp(props.item.content || '');

  });
});

// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef();

// 内容 HTML
const valueHtml = ref("<p>hello</p>");
const mode = ref("default");

const toolbarConfig = {};
const editorConfig = {
  placeholder: "请输入内容...",
  MENU_CONF: {
    uploadImage: {
      fieldName: "file",
      maxFileSize: 10 * 1024 * 1024, // 10M
      server: proxy.BASE_API_URL + "index/uploadX",
      headers: {
        "Accept-Token": getTokenAUTH(),
      },
      customInsert(res, insertFn) {
        console.log('富文本上传返回:', res)
        // 如果后端返回的URL已经包含http或https协议，直接使用
        // 否则拼接IMG_BASE_URL
        let url = res.data.url;
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = proxy.IMG_BASE_URL + url;
        } else {
          // 如果是http开头，替换为https
          url = url.replace('http://', 'https://');
        }
        const alt = res.data.alt
        const href = res.data.href
        insertFn(url, alt, href);
      },
      onError(file, err, res) {
        console.log(`${file.name} 上传出错`, err, res)
      }
    },
  },
};

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
});

const handleCreated = (editor) => {
  editorRef.value = editor; // 记录 editor 实例，重要！
};

defineExpose({ form });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}

.demo-form-inline .el-input {
  --el-input-width: 420px;
}

.demo-form-inline .el-select {
  --el-select-width: 420px;
}

/deep/ .el-radio-group {
  width: 420px;
}

.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}

/deep/ .el-form-item {
  align-items: flex-start;
}
</style>
